import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Typography } from '@totalsoft/rocket-ui';

const Header = props => {
  const { t } = useTranslation();
  const { title } = props;
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {t('DocumentTypes.DocumentWithAllowedStates.AllowedStateTitle', { documentTypeName: title.documentTypeName })}
      <i>{title.allowedStateName}</i>
    </Typography>
  );
};

Header.propTypes = {
  title: PropTypes.object.isRequired
};

export default Header;
